import { render } from "./TimeIcon.vue?vue&type=template&id=d0bf30f2"
import script from "./TimeIcon.vue?vue&type=script&lang=js"
export * from "./TimeIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__